import "./label_list.js";
import "./label_selector.js";
import "./label_creator.js";

(function ($) {
  window.LabelApplier = function (container) {
    container = jQuery(container);
    var labelListContainer = container.find(".label-list.target-list");
    var labelSelectorContainer = container.find(".label-selector");
    var labelCreatorContainer = container.find(".label-creator");
    var selectLabelButton = container.find(".select_label_button");
    var createLabelButton = container.find(".create_label_button");

    var labelList = new LabelList(labelListContainer);
    var labelCreator = new LabelCreator(labelCreatorContainer);
    var labelSelector = new LabelSelector(labelSelectorContainer);

    // BEHAVIOUR

    selectLabelButton.on("click", showLabelSelector);
    createLabelButton.on("click", showLabelCreator);
    jQuery(labelCreator).on("labelCreated", labelCreatedHandler);
    jQuery(labelSelector).on("labelSelected", labelSelectedHandler);
    jQuery(labelListContainer).on("labelAdded", handleLabelAdded);
    labelListContainer.find(".remove").on("click", removeLabellistItem);

    // EVENT HANDLERS

    function handleLabelAdded(e, labelJSON) {
      // If the form has remove pills run remove click handlers
      labelListContainer.find("[data-label-id=" + labelJSON.id + "] .remove").on("click", removeLabellistItem);
    }

    function removeLabellistItem(e) {
      var id = jQuery(e.target).closest("[data-label-id]").data("labelId");
      labelSelector.toggleLabel({ id: id });
      labelList.removeLabel({ id: id });
    }

    function labelCreatedHandler(event, labelJSON) {
      labelSelector.addLabel(labelJSON).find(".checkmark").trigger("click");
      showLabelSelector();
    }

    function labelSelectedHandler(event, labelJSON) {
      labelList.toggleLabel(labelJSON);
    }

    // HELPER FUNCTIONS

    function showLabelSelector() {
      labelSelectorContainer.show();
      selectLabelButton.addClass("--selected");
      createLabelButton.removeClass("--selected");
      labelCreatorContainer.hide();
    }

    function showLabelCreator() {
      labelSelectorContainer.hide();
      selectLabelButton.removeClass("--selected");
      createLabelButton.addClass("--selected");
      labelCreatorContainer.show();
    }

    // INITIALIZE

    if (labelSelector.labels().length) {
      showLabelSelector();
    } else {
      showLabelCreator();
    }
  };
})(jQuery);
